import axios from "axios";
import React, { useEffect, useState } from "react";
import { Veiculo } from "../../../Models/Cadastros/Veiculo/Veiculo";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import TabHeaderComponent from "../../../Components/Navigations/SimpleTabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/SimpleTabPanelComponent";
import VeiculoDadosTab from "./VeiculoDadosTab";

const VeiculoCadastroPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [veiculo, setVeiculo] = useState<any>(new Veiculo());
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if ((props.veiculo?.id ?? 0) != 0) {
            setVeiculo(props.veiculo);
        }
    }, []);
    
    async function save() {
        try {
            let responseId: any = null;
            if (veiculo?.id == null ||veiculo?.id == 0 || veiculo?.id == '') {
                let response = await axios.post('veiculos', veiculo);
                responseId = response.data.id;
            }
            else {
                let response = await axios.put(`veiculos/${veiculo.id}`, veiculo);
                responseId = response.data.id;
            }

            enqueueSnackbar('Salvo com sucesso!', {variant: 'success'});
            let responseVeiculo: any = await axios.get(`veiculos/${responseId}`);
            setVeiculo(responseVeiculo.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', {variant: 'error'});
        }
        finally {
            document.body.style.cursor = "default";
        }
    }
    
    return (
        <PopupBasePage title="Veículo" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={save} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Cadastro Veículo" tabs={['Dados', 'Checklist', 'Histórico']} tab="veiculo" />

                        <form className="needs-validation" id="formVeiculoDados">
                            <TabPanelComponent value={tabValue} index={0} tab="veiculo" tabHeader="veiculo">
                                <VeiculoDadosTab veiculo={veiculo} />
                            </TabPanelComponent>
                        </form>

                        <TabPanelComponent value={tabValue} index={1} tab="veiculo" tabHeader="veiculo">
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={2} tab="operacao" tabHeader="veiculo">
                        </TabPanelComponent>

                    </div>
                </div>
            </div >
        </PopupBasePage >
    );
}

export default VeiculoCadastroPopup;